import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import MessagesList from './components/MessagesList/MessagesList';

import watch from './assets/images/watch.png';
import headphones from './assets/images/headphones.png';
import phone from './assets/images/phone.png';
import alisa from './assets/images/alisa.png';
import clearLine from './assets/images/clearLine.png';
import { useState } from 'react';
import { useLayoutEffect } from 'react';
import { createImage } from './helpers/titreHelper';
import { useEffect } from 'react';

function App() {
  const {
    currentState,
    isVisible,
    showedMessages,
    winnerMessage,
    speed,
    winIds,
  } = useCarousel();
  const { bg, authorFontSize, msgFontSize, phoneNumberFontSize, bgColor } =
    useGetParams();

  const [prize, setPrize] = useState({ src: 'default', left: 0, bottom: 0 });

  useEffect(() => {
    let imgWrapper = document.getElementById('img-loader');
    if (imgWrapper) {
      imgWrapper.appendChild(createImage(alisa));
      imgWrapper.appendChild(createImage(clearLine));
      imgWrapper.appendChild(createImage(headphones));
      imgWrapper.appendChild(createImage(watch));
      imgWrapper.appendChild(createImage(phone));
    }
  }, []);

  useLayoutEffect(() => {
    if (currentState === 'S10' || !currentState) {
      setPrize({
        src: 'default',
        left: '0',
        bottom: '0',
      });

      return;
    }

    if (currentState === 'S5') {
      if (prize.src !== alisa) {
        setPrize(() => ({
          src: alisa,
          left: '5rem',
          bottom: '0',
          width: '70.21rem',
          height: '51.56rem',
        }));
      }
    } else if (currentState === 'S6') {
      if (prize.src !== clearLine) {
        setPrize(() => ({
          src: clearLine,
          left: '0',
          bottom: '0',
          width: '72.6rem',
          height: '66.04rem',
        }));
      }
    } else if (currentState === 'S7') {
      if (prize.src !== headphones) {
        setPrize(() => ({
          src: headphones,
          left: '20rem',
          bottom: '10rem',
          width: '49.06rem',
          height: '55.21rem',
        }));
      }
    } else if (currentState === 'S8') {
      if (prize.src !== watch) {
        setPrize(() => ({
          src: watch,
          left: '13rem',
          bottom: '5rem',
          width: '49.79rem',
          height: '50.83rem',
        }));
      }
    } else if (currentState === 'S9') {
      if (prize.src !== phone) {
        setPrize(() => ({
          src: phone,
          left: '0rem',
          bottom: '-1rem',
          width: '59.58rem',
          height: '62.5rem',
        }));
      }
    }
  }, [currentState]);

  return (
    <div
      className="app-wrapper"
      style={{
        background:
          bg && bg !== '0'
            ? `url(${
                bg === '1' ? defaultBackground : bg
              })center/cover no-repeat, ${bgColor}`
            : `none, ${bgColor}`,
        '--speed': `${speed || 0}ms`,
        '--delay': `${speed / 2 || 0}ms`,
      }}
    >
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <div className="message-wrapper">
          <CSSTransition
            in={showedMessages && Boolean(currentState)}
            timeout={500}
            // classNames="fade-scale"
            unmountOnExit
          >
            <MessagesList
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              authorFontSize={authorFontSize}
              msgFontSize={msgFontSize}
              phoneNumberFontSize={phoneNumberFontSize}
              currentState={currentState}
              speed={speed || 0}
              winIds={winIds}
            />
          </CSSTransition>
        </div>
      </CSSTransition>

      <SwitchTransition>
        <CSSTransition
          key={prize.src}
          addEndListener={(node, done) =>
            node.addEventListener('transitionend', done, false)
          }
          classNames="fade-scale"
        >
          <div
            className="prize"
            style={{
              left: prize.left,
              bottom: prize.bottom,
              width: prize?.width,
              height: prize?.height,
            }}
          >
            {Boolean(currentState) &&
              currentState !== 'S10' &&
              prize.src !== 'default' && <img src={prize.src} alt="" />}
          </div>
        </CSSTransition>
      </SwitchTransition>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
